/**
 * @typedef {Object} User
 * @property {number} id
 * @property {string} firstname
 * @property {string} lastname
 * @property {string} email
 * @property {string} zip
 * @property {string} lang
 * @property {string} token
 * @property {string} referralToken
 * @property {string} destination
 * @property {boolean|null} isSubscribedToContestMessages
 */

import ApiService from "../ApiService"
import store from "../../store"

class UserService extends ApiService {
  /**
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super(`${process.env.VUE_APP_CONTEST_API}api/v1/users`, parameters)
  }

  /**
   * @param {Object} data
   * @param {string} data.firstname
   * @param {string} data.lastname
   * @param {string} data.email
   * @param {string} data.zip
   * @param {string} data.destination
   * @param {string|null} [data.referrer]
   * @return {Promise<{data: User}>}
   */
  create(data) {
    const utms = `?${store.getters["app/utmQs"]}`
    return this.removeParameters()
      .submit("post", `${this.endpoint}${utms}`, data)
      .then(res => {
        return res.data
      })
  }

  /**
   * Get user
   * @param {number} id
   * @param {string} token
   * @return {Promise<unknown>}
   */
  get(id, token) {
    return this.removeParameters()
      .submit("get", `${this.endpoint}/${id}?t=${token}`)
      .then(res => {
        return res.data
      })
  }

  unsubscribe({ token, isContestUser }) {
    const url = isContestUser
      ? `${process.env.VUE_APP_CONTEST_API}api/v1/unsubscribe?t=${token}`
      : `${process.env.VUE_APP_CONTEST_API}api/v1/unsubscribe?u=${token}`

    return this.removeParameters()
      .submit("post", url)
      .then(res => {
        return res.data
      })
  }
}

export default UserService
